import React, { Children } from 'react';
import * as _ from 'lodash';
import * as FormEle from './FieldFormElements';
import {
  CCUS_ORDER_TYPE,
  CCUS_CONSTRUCTURE_TYPE,
} from '../utilities/constants';
import { CcusLineComponent } from './CcusFormComponent';

const CCUS_REQUIRED_ELEMENTS = {
  ADDRESS_PREFECTURE: { name: 'address_prefecture' },
  ADDRESS_PREFECTURE_KANA: { name: 'address_prefecture_kana' },
  ADDRESS_CITY: { name: 'address_city' },
  ADDRESS_CITY_KANA: { name: 'address_city_kana' },
  ADDRESS_ADD_1: { name: 'address_add_1' },
  ADDRESS_ADD_1_KANA: { name: 'address_add_1_kana' },
};

class Observer {
  constructor() {
    this.listener = [];
  }
  subscribe(listener) {
    this.listener.push(listener);
  }
  publish() {
    this.listener.map(event => {
      event();
    });
  }
}

class Store {
  constructor() {
    this.Observer = new Observer();
    this.state = {
      validate_elements: CCUS_REQUIRED_ELEMENTS,
    };
  }

  set(key, value) {
    this.state[key] = value;
    this.Observer.publish();
  }

  forceUpdate() {
    this.Observer.publish();
  }

  getState(key) {
    return this.state[key];
  }

  subscribe(listener) {
    this.Observer.subscribe(listener);
  }

  destroy() {
    this.state = {};
    this.Observer.publish();
  }

  validateAll() {}
}
export const ccusStore = new Store();

export class CcusProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      storestate: {},
      value: null,
    };

    this.EventMg = props.EventMg;

    ccusStore.subscribe(() => {
      this.setState({
        value: ccusStore.getState(props.id),
      });
    });
  }

  componentDidMount() {
    ccusStore.forceUpdate();
    if (this.props.value) {
      ccusStore.set(this.props.id, this.props.value);
    }
  }

  componentWillUnmount() {
    ccusStore.set(this.props.id, null); // 画面遷移などでデータが他の画面で表示されないようにする
  }

  componentDidUpdate(prevProps, prevState) {
    //初期値が空の場合に設定
    if (!prevProps.defaultValue && this.props.defaultValue) {
      ccusStore.set(this.props.id, this.props.defaultValue);
    }
    //props.valueが変化した場合のみ
    if (
      prevState.value === this.state.value &&
      prevProps.value !== this.props.value
    ) {
      ccusStore.set(this.props.id, this.props.value);
    }
  }

  onUpdate(value, params, target) {
    this.props.onUpdate(value, params, target);
    ccusStore.set(this.props.id, value);
  }

  onValidationCheck(value = null) {
    this.EventMg.trigger('input_change_value', {
      id: this.props.id,
      value: _.isNull(value) ? this.state.value : value,
    });
  }

  getChildren() {
    return Children.map(this.props.children, child => {
      let newProps = _.clone(this.props);
      newProps.onUpdate = this.onUpdate.bind(this);
      newProps.value = this.state.value;
      newProps.onValidationCheck = this.onValidationCheck.bind(this);
      return React.cloneElement(child, newProps);
    });
  }

  render() {
    return <React.Fragment>{this.getChildren()}</React.Fragment>;
  }
}

/**
 * 現場登録フォーム要素を拡張
 * 既存のフォームをラップして、ccusのボタンと表示を追加
 * 内部の変更をStoreにセットしてCcusProviderからpropsに
 * @param {*} state
 */
const ccusWrapped = state => WrappedComponent => {
  class ccusForm extends React.Component {
    constructor(props) {
      super(props);
      if (_.isFunction(state)) {
        this.state = state(props);
      } else {
        this.state = state;
      }
    }

    setCcusValue() {
      this.props.EventMg.trigger('input_change_value', {
        id: this.props.id,
        value: this.props.ccusValue,
      });
      ccusStore.set(this.props.id, this.props.ccusValue);
    }

    getCcusValue(val) {
      if (!val) {
        return '';
      }

      //発注区分
      if (this.props.id === 'ordering_type_id') {
        const order_type = _.filter(CCUS_ORDER_TYPE, type => {
          return type.id === +val;
        });
        return order_type.length ? order_type[0].name : '';
      }

      //工事種類
      if (this.props.id === 'construction_type_id') {
        const construction_type = _.filter(CCUS_CONSTRUCTURE_TYPE, type => {
          return type.id === +val;
        });
        return construction_type.length ? construction_type[0].name : '';
      }

      return val;
    }

    ccusElement(value) {
      return (
        <CcusLineComponent
          onClick={() => {
            this.setCcusValue();
          }}
        >
          {this.getCcusValue(value)}
        </CcusLineComponent>
      );
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          ccusFormElement={
            this.props.ccusValue ? this.ccusElement(this.props.ccusValue) : null
          }
        />
      );
    }
  }

  ccusForm.displayName = `${state.displayName}`;
  return ccusForm;
};

export const CcusFormHoc = label => {
  return ccusWrapped(() => {
    return { displayName: label };
  })(FormEle[label]);
};



// WEBPACK FOOTER //
// ./src/components/FieldFormElementsCcusProvider.jsx